import { postRestRequest } from '../../../helpers/RestHelpers'
import { api } from '../../../configuration'

type MessageResponse = {
  status?: boolean
}

export type MessagesParams = {
  data: {
    firstName: string
    lastName: string
    message: string
    email: string
    recipient: string
  }
}

const addMessage = ({ ...data }: MessagesParams) =>
  postRestRequest({
    url: api.REST_API_URL + `/messages`,
    data,
    transformer: (response: MessageResponse): boolean => {
      return !!response?.status
    },
  })

export default addMessage
